/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import {
  BlacklistItemValidityDtoModel,
  VendorBlacklistItemDtoModel
} from '@well/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VendorBlacklistItemResourceService extends AbstractResourceService<never,
  VendorBlacklistItemDtoModel,
  never,
  never> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('vendorBlacklistItemUrl'),
      undefined,
      undefined
    );
  }
  getVendorBlacklistHistory(vendorUuid: string) : Observable<JsonApiResource<BlacklistItemValidityDtoModel[], JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<BlacklistItemValidityDtoModel[], JsonApiListResourceMetadataBase>> >this.httpClient?.get(`${this.url}/validity/history/${vendorUuid}`);
  }
}
